//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
export default {
  name: "FileUpload",
  data() {
    return {
      file: "",
      message: "",
    };
  },
  methods: {
    onSelect() {
      const file = this.$refs.file.files[0];
      this.file = file;
    },
    async onSubmit() {
      const formData = new FormData();
      formData.append("file", this.file);

      try {
        await axios.post(
          this.$store.getters.getApi + "upload",
          {
            crossDomain: true,
          },
          formData
        );
        this.message = "Uploaded";
      } catch (err) {
        this.message = "smth went wrong";
      }
    },
  },
};
